import { graphql } from '@/graphql-setup'

export const SIDEBAR_QUERY = graphql(`
  query Sidebar(
    $workPeriodStartDate: DateTime!
    $filterEndDate: DateTime!
    $user: ID!
    $infringementUser: ID
    $lastYear: DateTime!
  ) {
    allIssues(
      closedAt_Isnull: true
      archivedAt_Isnull: true
      relatedInfringement: null
    ) {
      totalUnresolvedCount
    }
    absenceCountByStatus(status: PENDING)
    allInfringements(
      user: $infringementUser
      infringementTimestamp_Gte: $lastYear
      archivedAt_Isnull: true
      closedBy_Isnull: true
    ) {
      total
    }
    allWorkPeriods(
      user: $user
      datetimeStart: $workPeriodStartDate
      datetimeEnd: $filterEndDate
    ) {
      total
    }
    allFormTemplates(excludeArchived: true, onlyMenuShortcuts: true) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`)
